
export default function Logo({ className = "h-12" }: { className?: string }) {
  return (
    <div className={`flex items-center gap-2.5 ${className}`}>
      <div className="relative flex-shrink-0">
        <div className="w-9 h-9 bg-emerald-500 rounded-lg flex items-center justify-center">
          <i className="ri-car-line text-lg text-white"></i>
        </div>
        <div className="absolute -top-1 -right-1 w-4 h-4 bg-amber-400 rounded-full flex items-center justify-center">
          <i className="ri-check-line text-[9px] text-slate-900 font-bold"></i>
        </div>
      </div>
      <div className="flex flex-col leading-none">
        <span className="text-lg font-black text-white tracking-tight">ALAFIJAYA</span>
        <span className="text-[9px] font-semibold text-emerald-400 tracking-widest uppercase mt-0.5">
          Sistema Automotriz
        </span>
      </div>
    </div>
  );
}
